/**
 * @see https://api.prezly.com/v2/common/schema.json#/definitions/Pagination
 */

export let SelectionMode = /*#__PURE__*/function (SelectionMode) {
  SelectionMode["ALL"] = "all";
  SelectionMode["IN"] = "in";
  SelectionMode["NOT_IN"] = "not_in";
  return SelectionMode;
}({});